import { Route, NavLink, Routes, Navigate } from 'react-router-dom';
import styles from './trimrom.module.css';
import trimrom from './trimrom1.webp';
import trimrom2 from './trimrom2.webp';

// import actionPicture from './pictures/barnepartiaction.webp'

function TrimromInformation() {
    return (
        <div className="fadeIn">
            <p>Ski Taekwondo Klubb har et helt eget trimrom i treningslokalet med forskjellige treningsapparater, vekter, tredemøller og mer.</p>
            <p>Trimrommet er ikke bare for utøvere i Ski Taekwondo Klubb, men også foreldre til medlemmer i Ski Taekwondo Klubb som ønsker å trene på trimrommet imens barna trener taekwondo!</p>
            <a href={trimrom} target="_blank"><img title="Trykk for større oversikt" src={trimrom} alt="Annen vinkel av Ski taekwondo klubb sitt trimrom"/></a>
            <p>Både utøvere og foreldre kan i tillegg til dette få en nøkkelbrikke for å trene utenfor normale treningstider. Dette gir deg stor frihet til å trene når det passer deg.</p>
            <p>Trimrommet er en ypperlig måte for foreldre å trene selv på eget initiativ samtidig som barnet og til en penere pris enn treningsstudio.</p>
            <p>Aldersgrense for bruk av trimrommet: 16 år.</p>
        </div>

    )
}

function Priser() {
    return (
        <div className="fadeIn">
            <h2 className={styles.price}>Per måned: 210,-</h2>
            <small>Gebyr fra Norges Kampsportforbund på 5,- kommer i tillegg</small>
            <h2 className={styles.margin}>Om medlemskontigent:</h2>
            <p>Vi har avtalegiro basert på NIF og NKF sine retningslinjer for å sikre at alle er registrert og forsikret etter gjeldende regler.</p>
            <p>Medlemskapet er løpende frem til det er skriftlig sagt opp.</p>
            <p>I tillegg til månedsgebyr er det en kontigent til Norges Idrettsforbund (kr 350) som vil bli belastet i april hvert år.</p>
            <p>Denne kontingenten inkluderer årskontingent til Norges Kampsportforbund (NKF) som inkluderer forsikring og medlemspass.</p>
        </div>
    )
}

function Navigation() {
    return (
        <>
            <h1>Trimrommet</h1>
            <div className={styles.subButtons}>
                <NavLink to="informasjon" className={({ isActive }) => isActive ? styles.buttonActive : ""}>
                    <button>
                        <span>Informasjon</span>
                    </button>
                </NavLink>
                <NavLink to="priser" className={({ isActive }) => isActive ? styles.buttonActive : ""}>
                    <button>Priser</button>
                </NavLink>
            </div>
        </>
    )
}

function Barneparti() {
    return (
        <div className={`${styles.trimromGrid} `}>
            <div className={`${styles.picture} fadeInHomeBG`}>
                <a href={trimrom2} target='_blank'>
                    <img src={trimrom2} title="Trykk for større oversikt" alt="Bilde av Ski taekwondo klubb sitt trimrom"/>
                </a>
            </div>
            <div className={`${styles.textSide} slideLeft`}>
                <Navigation/>
                <Routes>
                    <Route path='priser' element={ <Priser/> }/>
                    <Route path='informasjon' element={ <TrimromInformation/> }/>
                    <Route path='/' element={ <Navigate to="informasjon" /> }/>
                </Routes>
            </div>
        </div>
    )
}

export default Barneparti;